var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3125C14.206 14.3125 16 12.5185 16 10.3125C16 8.1065 14.206 6.3125 12 6.3125C9.794 6.3125 8 8.1065 8 10.3125C8 12.5185 9.794 14.3125 12 14.3125ZM12 8.3125C13.103 8.3125 14 9.2095 14 10.3125C14 11.4155 13.103 12.3125 12 12.3125C10.897 12.3125 10 11.4155 10 10.3125C10 9.2095 10.897 8.3125 12 8.3125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4201 22.1265C11.5893 22.2474 11.7921 22.3123 12.0001 22.3123C12.2081 22.3123 12.4108 22.2474 12.5801 22.1265C12.8841 21.9115 20.0291 16.7525 20.0001 10.3125C20.0001 5.9015 16.4111 2.3125 12.0001 2.3125C7.58909 2.3125 4.00009 5.9015 4.00009 10.3075C3.97109 16.7525 11.1161 21.9115 11.4201 22.1265ZM12.0001 4.3125C15.3091 4.3125 18.0001 7.0035 18.0001 10.3175C18.0211 14.7555 13.6121 18.7405 12.0001 20.0475C10.3891 18.7395 5.97909 14.7535 6.00009 10.3125C6.00009 7.0035 8.69109 4.3125 12.0001 4.3125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMark);
export default __webpack_public_path__ + "static/media/locationMark.90bdccd18613ef9b7ef697b7fbe7949b.svg";
export { ForwardRef as ReactComponent };